module.exports = __webpack_public_path__ + "static/media/BIFI-MATIC.de402eec.png";